import { render, staticRenderFns } from "./VerifyDetails.vue?vue&type=template&id=57fa7a96&scoped=true"
import script from "./VerifyDetails.vue?vue&type=script&lang=js"
export * from "./VerifyDetails.vue?vue&type=script&lang=js"
import style0 from "./VerifyDetails.vue?vue&type=style&index=0&id=57fa7a96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57fa7a96",
  null
  
)

export default component.exports